import type { Lang } from '../store';
import { tr } from '../i18n';
import { shellHeader, shellFooter, brandLockup } from './shell';

export function renderIdle(lang: Lang): string {
  const L = tr(lang);
  return /* html */ `
    ${shellHeader(lang)}
    <main class="sq-hero">
      ${brandLockup()}
      <div class="sq-event-tag">Vara 2026</div>

      <div class="sq-status-pill">
        <span class="sq-status-dot"></span>
        <span>${L.pill_idle}</span>
      </div>

      <h1>${L.idle_title_1}<br/>${L.idle_title_2} <em>${L.idle_title_em}</em></h1>
      <p class="lead">${L.idle_lead}</p>

      <div class="sq-stats" data-stats-strip>
        <div class="sq-stat">
          <span class="sq-stat-n" data-count="5">0</span>
          <span class="sq-stat-l">${L.stat_spots}</span>
        </div>
        <div class="sq-stat-sep"></div>
        <div class="sq-stat">
          <span class="sq-stat-n" data-count="13">0</span>
          <span class="sq-stat-l">${L.stat_drops}</span>
        </div>
        <div class="sq-stat-sep"></div>
        <div class="sq-stat">
          <span class="sq-stat-n" data-count="65">0</span>
          <span class="sq-stat-l">${L.stat_dogs}</span>
        </div>
      </div>

      <div class="sq-status-card">
        <h2>${L.idle_card_title}</h2>
        <p>${L.idle_card_text}</p>
      </div>

      <section class="sq-how">
        <div class="sq-section-title">${L.how}</div>
        <div class="sq-steps">
          ${L.steps
            .map(
              (s, i) => `
            <div class="sq-step">
              <div class="sq-step-num">0${i + 1}</div>
              <div class="sq-step-body">
                <h3>${escapeHtml(s.t)}</h3>
                <p>${escapeHtml(s.d)}</p>
              </div>
            </div>
          `,
            )
            .join('')}
        </div>
      </section>
    </main>
    ${shellFooter(lang)}
  `;
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}
